<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="refunds"
      :loading="loading"
      :loading-text="$t('refund.refundsLoading')"
      :no-data-text="$t('refund.noRefunds')"
      dense
      disable-pagination
      hide-default-footer
      item-key="id"
      mobile-breakpoint="768"
    >
      <template v-slot:item.current_status="{ item }">
        <v-chip
          small
          :color="getRefundStatusBackgroundColor(item.current_status)"
          :text-color="getRefundStatusTextColor(item.current_status)"
          dark
        >
          {{ getRefundStatusTranslation(item.current_status) }}
        </v-chip>
      </template>
      <template v-slot:item.amount="{ item }">
        <span>{{ formatAmount(item.amount, item.currency) }}</span>
        {{ getCurrencyCode(item.currency) }}
      </template>
      <template v-slot:item.amount_exclude_tax="{ item }">
        <span>{{ formatAmount(item.amount_exclude_tax, item.currency) }}</span>
        {{ isAmountDefined(item.amount_exclude_tax) ? getCurrencyCode(item.currency) : '' }}
      </template>
      <template v-slot:item.refunded_products="{ item }">
        <span>{{ getNbProductsRefunded(item.items) }}</span>
      </template>
      <template v-slot:item.details="{ item }">
        <v-btn
          :class="[!isMobile ? '' : 'pr-0']"
          color="primary"
          text
          @click="goToRefundDetail(item.refund_id)"
        >
          {{ $t('refund.viewDetails') }}
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import {
    getRefundStatusBackgroundColor,
    getRefundStatusTextColor,
    getRefundStatusTranslation,
    getNbProductsRefunded,
    isAmountDefined,
    getCurrencyCode,
  } from '@/helpers/refundHelper'

  export default {
    name: 'ordersRefundsTable',
    props: {
      refunds: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      headers() {
        return [
          { text: this.$t('refund.reference'), value: 'refund_id', sortable: false },
          { text: this.$t('refund.status'), value: 'current_status', sortable: false },
          { text: this.$t('refund.amountWithTax'), value: 'amount', sortable: false },
          { text: this.$t('refund.amountWithoutTax'), value: 'amount_exclude_tax', sortable: false },
          { text: this.$t('order.refundedProducts'), value: 'refunded_products', sortable: false },
          { text: '', value: 'details', sortable: false },
        ]
      },
    },
    methods: {
      getRefundStatusBackgroundColor,
      getRefundStatusTextColor,
      getRefundStatusTranslation,
      getNbProductsRefunded,
      isAmountDefined,
      getCurrencyCode,
      /**
       * Formats a refund amount, falling back to a placeholder when it is not defined,
       * so an undefined/NaN amount never reaches the formatPrice filter.
       *
       * @param {unknown} amount - The raw refund amount.
       * @param {object|undefined} currency - The refund currency.
       * @returns {string} The formatted price or a placeholder.
       */
      formatAmount(amount, currency) {
        if (!this.isAmountDefined(amount)) {
          return '-'
        }
        return this.$options.filters.formatPrice(amount, currency)
      },
      goToRefundDetail(refundId) {
        this.$router.push({ name: 'refundDetails', params: { id: refundId } })
      },
    },
  }
</script>
